import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { PAGE_NAME, ROUTES } from "@/app/app-constants";

const BASE_TITLE = "Relay Yard Hub";

const APPLICATION_ROUTES = [
  { path: ROUTES.RYC, applicationName: PAGE_NAME.RYC },
  { path: ROUTES.APPOINTMENTS, applicationName: PAGE_NAME.APPOINTMENTS },
  { path: ROUTES.EQUIPMENT, applicationName: PAGE_NAME.EQUIPMENT },
  { path: ROUTES.RYT, applicationName: PAGE_NAME.RELAY_YARD_TRACKER },
  { path: ROUTES.RYTE_TRACKER, applicationName: PAGE_NAME.RYTE_TRACKER },
  { path: ROUTES.OWNER_CONFIGURATION, applicationName: PAGE_NAME.OWNER_CONFIGURATION },
  { path: ROUTES.HOSTLER_POOL, applicationName: PAGE_NAME.HOSTLER_POOL },
  { path: ROUTES.AGENT_STUDIO, applicationName: PAGE_NAME.AGENT_STUDIO },
];

export const DocumentTitle: React.FC = () => {
  const { pathname } = useLocation();
  const applicationName = APPLICATION_ROUTES.find(
    ({ path }) => pathname === path || pathname.startsWith(`${path}/`)
  )?.applicationName;

  useEffect(() => {
    document.title = applicationName ? `${BASE_TITLE}: ${applicationName}` : BASE_TITLE;
  }, [applicationName]);

  return null;
};
